import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const rows = [
  { id: 'recipient', label: 'Destinataire' },
  { id: 'adress', label: 'Adresse' },
  { id: 'status', label: 'État de la commande' },
  { id: 'externalReference', label: 'Référence' },
  { id: 'trackingNumber', label: 'Numéro de suivi' },
  { id: 'finalCarrier', label: 'Transporteur' }
];

/**
 * Entête du tableau dans la section expéditions
 */
const EnhancedTableHead = () => (
  <TableHead>
    <TableRow>
      {rows.map(
        row => (
          <TableCell key={row.id} align="left" style={{ fontWeight: 'bold' }}>
            {row.label}
          </TableCell>
        ),
        this
      )}
    </TableRow>
  </TableHead>
);

export default EnhancedTableHead;
